import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informatii-acces-servicii',
  templateUrl: './informatii-acces-servicii.component.html',
  styleUrls: ['./informatii-acces-servicii.component.scss']
})
export class InformatiiAccesServiciiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
